import * as React from 'react';

function SvgWallet(props) {
  return (
    <svg
      id="prefix__Group_876"
      data-name="Group 876"
      xmlns="http://www.w3.org/2000/svg"
      width={18.42}
      height={18.42}
      {...props}
    >
      <defs>
        <style>{`.prefix__cls-1{fill:${props.fill} !important}`}</style>
      </defs>
      <g id="prefix__Group_12" data-name="Group 12">
        <g id="prefix__Group_11" data-name="Group 11">
          <g id="prefix__Group_10" data-name="Group 10">
            <path
              id="prefix__Path_14"
              data-name="Path 14"
              className="prefix__cls-1"
              d="M187.947 113.45h3.431v-3.074a1.083 1.083 0 00-1.084-1.084h-13.273a.813.813 0 010-1.625h12.731v-1.084a1.083 1.083 0 00-1.084-1.084h-13a2.167 2.167 0 00-2.167 2.167v14.086a2.167 2.167 0 002.167 2.167h14.628a1.083 1.083 0 001.084-1.084v-2.705h-3.431a3.341 3.341 0 110-6.682z"
              transform="translate(-173.5 -105.5)"
            />
            <path
              id="prefix__Path_15"
              data-name="Path 15"
              className="prefix__cls-1"
              d="M202.188 122.674h-3.7a1.986 1.986 0 100 3.973h3.7a.271.271 0 00.271-.271v-3.431a.271.271 0 00-.271-.271zm-3.251 2.8a.813.813 0 11.813-.813.813.813 0 01-.812.812z"
              transform="translate(-184.04 -113.37)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgWallet;
